import { USER, GUEST, TEACHER, ORGANISER, PHANTOM,
    NOT_A_MEMBER, POGANY, BALEK, FIRMA,
    PRAESES, MAJORDOMUS, CONTRAPUNKT, CANTUSPRAESES,
    ETALONRESZEG, KONZEKVENCIA, PATERKRAMPAMPULI,
    FOAJTONALLO, FOGARATOR, GARATOR, FUCHSMAJOR, FUHRWERK } from "../Data/Constants";

export function memberStateToString(memberState) {
    switch (memberState) {
        case NOT_A_MEMBER: return "Nem tag";
        case POGANY: return "Pogány";
        case BALEK: return "Balek";
        case FIRMA: return "Firma";
        default: return "n/a";
    }
}

export function roleNameToHungarian(roleName) {
    switch (roleName) {
        case "Member": return "Körtag";
        case "Admin": return "Adminisztrátor";
        default: return "n/a";
    }
}

export function eventRegistrationTypeToString(eventRegType) {
    switch (eventRegType) {
        case USER: return "Normál";
        case GUEST: return "Vendég";
        case ORGANISER: return "Rendező";
        case TEACHER: return "Tanár";
        case PHANTOM: return "Fantom";
        default: return "n/a";
    }
}

export function postTypeToString(postType) {
    switch (postType) {
        case 0: return "";
        case PRAESES: return "Praeses";
        case MAJORDOMUS: return "Major Domus";
        case CONTRAPUNKT: return "Contrapunkt";
        case CANTUSPRAESES: return "Cantus Praeses";
        case ETALONRESZEG: return "Etalonrészeg";
        case KONZEKVENCIA: return "Konzekvencia";
        case PATERKRAMPAMPULI: return "Pater Krampampuli";
        case FOAJTONALLO: return "Főajtónálló";
        case FOGARATOR: return "Főgaratőr";
        case GARATOR: return "Garatőr";
        case FUCHSMAJOR: return "Fuchsmajor";
        case FUHRWERK: return "Fuhrwerk";
        default: return "n/a";
    }
}

export function taskStateToString(taskState) {
    switch (taskState) {
        case 0: return "Nincs elvégezve";
        case 1: return "Folyamatban";
        case 2: return "Elvégezve";
        default: return "n/a";
    }
}

export function registrationStateToString(state) {
    switch (state) {
        case 0: return "Jelentkezve";
        case 1: return "Lemondva";
        case 2: return "Beosztva";
        case 3: return "Nincs beosztva";
        default: return "n/a";
    }
}

export function stringToUrlEncoded(string) {
    return encodeURI(string.toLowerCase()
        .replace(/á/g, "a")
        .replace(/é/g, "e")
        .replace(/í/g, "i")
        .replace(/[óöő]/g, "o")
        .replace(/[úüű]/g, "u")
        .replace(/[ ,.?:_§'"+!%/=()*]/g, "-"));
}

export function reactTableDataToUrl(url, searchParams) {
    let result = `${url}?page=${searchParams.page}&pageSize=${searchParams.pageSize}`;

    if (searchParams.sorted && searchParams.sorted.length > 0) {
        result += "&sort=";
        searchParams.sorted.forEach(item => {
            result += `${item.id}:${item.desc?"desc":"asc"},`;
        });
        result = result.substring(0, result.length-1); //remove last comma
    }

    if(searchParams.filtered && searchParams.filtered.length > 0) {
        searchParams.filtered.forEach(element => {
            result += `&${element.id}=${element.value}`;
        });
    }

    return result;
}